import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showAssignModal = this.showAssignModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal   : false,
      targets : [],
      not_dm_list : [],
      contract_info : {},
    };
  }
  // -------------------------------------------------------
  
  showAssignModal(project_id, targets) {
    
    let data = { project_id: project_id };
    try {
      if( targets.length > 0 ){
        data.multi = targets;
      } else {
        data.insta_user_id = targets[0];
      }
    } catch(e) {}
    
    Utils.request.bind(this)('/api/project/influencer/auto_contract_money', data,
      function(res){
        
        this.setState({ modal: true, targets: targets, contract_info: res.body.contract_info, is_manual: false });
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  assignAction(dm_ng_flg) {
    if( dm_ng_flg == true ){
      let chk = confirm('アサイン依頼のDMができないアカウントが存在します。アサイン登録を行ってもよろしいですか？');
      if( chk == false ) return;
    }
    
    Utils.request.bind(this)('/api/project/influencer/assign_action', { project_id: this.props.data.project.id, targets: this.state.targets, contract_info: this.state.contract_info, not_dm_list: this.state.not_dm_list },
      function(res){
        
        if( res.body.is_message_error == true ){
          alert(this.state.targets.length +'人のインフルエンサーにアサインしました。一部DMの送信に失敗しています。ご確認よろしくお願いいたします。');
        } else {
          alert(this.state.targets.length +'人にアサインしました！');
        }
        
        this.closeAssignModal.bind(this)();
        this.props.data.event.updateData('workflow', res.body.workflow);
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  closeAssignModal() {
    this.setState({ modal: false, targets: [] });
  }
  // -------------------------------------------------------
  
  setNotDmList(insta_user_id) {
    let not_dm_list = this.state.not_dm_list;
    if( not_dm_list.indexOf(insta_user_id) == -1 ){
      not_dm_list.push(insta_user_id);
    } else {
      not_dm_list = not_dm_list.filter((id) => { if( id != insta_user_id ) return id; });
    }
    
    this.setState({ not_dm_list: not_dm_list });
  }
  // -------------------------------------------------------
  
  getSystemTypeMessage(insta_user_id, is_first, dm_ng_msg) {
    let system_link = (is_first == true) ? 'システム未連携' : 'システム連携済み';
    
    if( this.state.not_dm_list.indexOf(insta_user_id) >= 0 ){
      return (
        <div className="system-type-message is_none">
          <h6>{system_link}</h6>
          <p>依頼時にDMしません</p>
        </div>
      );
    }
    
    if( is_first == true && dm_ng_msg == null ){
      return (
        <div className="system-type-message is_first">
          <h6>{system_link}</h6>
          <p>アサイン依頼のDMをします<br />(システム登録の案内含む)</p>
        </div>
      );
    }
    
    if( is_first == true && dm_ng_msg != null ){
      return (
        <div className="system-type-message is_error">
          <h6>{system_link}</h6>
          <p>{dm_ng_msg}</p>
        </div>
      );
    }
    
    if( is_first == false && dm_ng_msg == null ){
      return (
        <div className="system-type-message is_manage_system">
          <h6>{system_link}</h6>
          <p>アサイン依頼のDMをします</p>
        </div>
      );
    }
    
    if( is_first == false && dm_ng_msg != null ){
      return (
        <div className="system-type-message is_error">
          <h6>{system_link}</h6>
          <p>{dm_ng_msg}</p>
        </div>
      );
    }
    
    return null;
  }
  // -------------------------------------------------------
  
  render() {
    let base     = this.props.data;
    let project  = base.project || {};
    let workflow = base.workflow || {};
    let detail   = project.detail;

    let influencers = [];
    this.state.targets.map((id) => {
      let inf = (workflow.influencers || {})[id];
      if( inf != undefined ){
        inf.contract_info = this.state.contract_info[id];
        influencers.push(inf);
      }
    });
    
    let is_single = (influencers.length == 1) ? 'is_single' : '';
    let is_error = false;
    
    let dm_thread = project.dm_thread;
    let dm_ng_flg = false;
    
    return (
      <div className="project-assign-setting-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {600}
          height    = {500}
          close_ev  = {this.closeAssignModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2>投稿内容と報酬を確認しましょう</h2>
              <h4>未設定の場合は、プロジェクトで設定した投稿内容と自動で金額を算出します</h4>
              
              <ul className={'influencers '+ is_single}>
                { influencers.map((d, key) => {
                  
                  let media_count = {};
                  Const.value.contents_type_list.map((c) => { media_count[c.id] = 0; });
                  try { d.contract_info.post_contents.map((d) => { media_count[d.media_type] += 1; }); } catch(e) {}
                  
                  let money = 0;
                  try { money = d.contract_info.money; } catch(e) {}
                  
                  let status = {};
                  try { if( d.contract_info.status != undefined ) status = d.contract_info.status; } catch(e) {}
                  
                  // エラー判定
                  let error_msg = null;
                  if( status.is_manage_system === 1 ){
                    if( error_msg == null && status.is_contract          !== 1 ) error_msg = '未基本契約';
                    if( error_msg == null && status.is_anti_social_check !== 1 ) error_msg = '未反社チェック';
                    if( error_msg == null && status.anti_social_flg      === 1 ) error_msg = '反社に該当';
                  }
                  
                  //if( error_msg != null ) is_error = true;
                  
                  // システム未連携アカウント
                  let is_first = (status.is_manage_system !== 1);
                  
                  // DM送信不可の場合
                  let dm_ng_msg = null;
                  if( dm_thread[d.insta_user_id] == undefined ) dm_ng_msg = '過去にDMを送信したことがありません';
                  if( detail.main_dm_account == null ) dm_ng_msg = 'アサイン用のDMアカウントが設定されていません';
                  
                  // DM未設定の場合
                  if( is_first == true && (detail.assign_message == null || detail.assign_message == '') ) dm_ng_msg = 'アサイン依頼DMメッセージ（未連携）が未設定です';
                  if( is_first == false && (detail.registered_message == null || detail.registered_message == '') ) dm_ng_msg = 'アサイン依頼DMメッセージ（連携済み）が未設定です';
                  
                  if( dm_ng_msg != null ) dm_ng_flg = true;
                  
                  return (
                    <li key={key}>
                      <p className="thumbnail"><img className="base-img" src={d.thumbnail} /></p>
                      <p className="insta-id">@{d.insta_id}</p>
                      
                      <p className="money">\{Utils.viewInt(money)}<span>(税別)</span></p>
                      
                      <div className="media-type">
                        { Const.value.contents_type_list.map((c, key) => {
                          return (
                            <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{c.name}</Tooltip>}>
                              <p className={'count_'+ media_count[c.id]}><i className={ c.id.toLowerCase() +' icon'} />{media_count[c.id]}</p>
                            </OverlayTrigger>
                          );
                        })}
                        
                        {/*
                        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>フィード</Tooltip>}>
                          <p className={'count_'+ media_count['FEED']}><i className="feed icon" />{media_count['FEED']}</p>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>リール</Tooltip>}>
                          <p className={'count_'+ media_count['REELS']}><i className="reels icon" />{media_count['REELS']}</p>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>ストーリー</Tooltip>}>
                          <p className={'count_'+ media_count['STORY']}><i className="story icon" />{media_count['STORY']}</p>
                        </OverlayTrigger>
                        */}
                      </div>
                      
                      { (error_msg != null) &&
  	                    <p className="alert"><i className="material-icons">warning</i>{error_msg}</p>
  	                  }
  	                  
  	                  { this.getSystemTypeMessage.bind(this)(d.insta_user_id, is_first, dm_ng_msg) }
  	                  
  	                  { (this.state.not_dm_list.indexOf(d.insta_user_id) == -1)
  	                    ? <div className="not-dm-message" onClick={this.setNotDmList.bind(this, d.insta_user_id)}>DMを送信しない</div>
  	                    : <div className="not-dm-message" onClick={this.setNotDmList.bind(this, d.insta_user_id)}>DMを送信する</div>
  	                  }
                    </li>
                  );
                })}
              </ul>
              
              { (is_error == true) && <p className="alert-msg">※確認が必要なアカウントがあります。詳しくは<i className="material-icons">warning</i>マークをご確認ください</p> }
              { (dm_ng_flg == true) && <p className="alert-msg">※DMを送信できないアカウントが存在します。<br /><a href={'/project-create/'+ project.unique_code +'/dm'} target="_blank">プロジェクト設定</a> または DMアカウントをご確認ください</p> }
              
              <h5>確認が完了しましたら以下のボタンを押してください (インフルエンサーに伝えられます)</h5>
              <div className="button" onClick={this.assignAction.bind(this, dm_ng_flg)}>案件を依頼する</div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;